import React, { useRef, useState, useEffect } from 'react';
import { Heart } from 'lucide-react';

const QR_URL = "/shunya-gatha-qr.jpg";

function FadeIn({ children, className = '' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.05 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={`transition-all duration-700 ${className}`}
      style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(30px)' }}>
      {children}
    </div>
  );
}

export default function DonationSection() {
  return (
    <section id="donate" data-testid="donation-section" className="py-20 sm:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn className="max-w-lg mx-auto text-center">
          <div className="glass-card rounded-2xl p-10 sm:p-12 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/5 via-transparent to-neonGold/5" />

            <div className="relative">
              <div className="w-14 h-14 mx-auto mb-6 rounded-full bg-pink-500/10 border border-pink-500/30 flex items-center justify-center">
                <Heart className="w-7 h-7 text-pink-400" />
              </div>

              <h2 className="font-heading text-3xl font-bold text-white mb-2">
                Support Shunya Gatha
              </h2>

              <p className="font-hindi text-pink-300/80 text-lg mb-6">
                अगर आपको हमारी कहानियां पसंद आती हैं, तो सपोर्ट करें
              </p>

              <div className="relative inline-block mb-6 group">
                <div className="absolute -inset-3 bg-gradient-to-r from-neonBlue/20 via-pink-500/20 to-neonGold/20 rounded-2xl blur-lg opacity-60 group-hover:opacity-100 transition-opacity" />
                <img
                  src={QR_URL}
                  alt="Donation QR Code"
                  data-testid="donation-qr"
                  className="relative w-52 h-52 rounded-xl ring-2 ring-white/10 bg-white p-2"
                />
              </div>

              <p className="text-gray-500 text-sm">
                Scan the QR code to support the author
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
